import React, { useEffect, useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";

export default function HelpSupport() {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      // ✅ .env use karega
      const API_BASE_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${API_BASE_URL}Rating/GetAllQuestions`
      );
      const data = await response.json();

      console.log("✅ Help & Support API:", data);
      setQuestions(data || []);
    } catch (error) {
      console.error("❌ API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-gray-50 via-white to-red-50]">

      {/* 🔥 HEADER */}
      <div className="w-full bg-gradient-to-r from-red-600 to-red-500 text-white py-12 px-6 md:px-16">
        <h2 className="text-3xl md:text-4xl font-bold text-center">
          Help & Support
        </h2>
        <p className="opacity-90 text-sm md:text-base mt-1 text-center">
          Find answers to common questions
        </p>
      </div>

      {/* 🔥 CONTENT */}
      <div className="px-6 md:px-16 py-10">

        {/* LOADING */}
        {loading && (
          <div className="grid gap-4 md:grid-cols-2">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="h-24 bg-gray-100 rounded-xl animate-pulse"
              />
            ))}
          </div>
        )}

        {/* EMPTY */}
        {!loading && questions.length === 0 && (
          <div className="text-center py-10 text-gray-500">
            <FaQuestionCircle size={40} className="mx-auto mb-3 opacity-50" />
            <p>No questions found</p>
          </div>
        )}

        {/* DATA */}
        <div className="grid gap-6 md:grid-cols-2">
          {questions.map((item, index) => (
            <div
              key={index}
              className="bg-white border rounded-2xl p-5 shadow-sm hover:shadow-xl hover:-translate-y-1 transition duration-300"
            >
              {/* QUESTION */}
              <h3 className="font-semibold text-gray-800 flex items-start gap-2">
                <span className="text-red-500 mt-1">Q.</span>
                {item.qusetion || item.question || item.questionName}
              </h3>

              {/* ANSWER */}
              {item.answer && (
                <p className="text-sm text-gray-600 mt-3 leading-relaxed">
                  {item.answer}
                </p>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}